import image from 'assets/images/dlImg.svg';
export const complianceDocumentData = [
    {
        id:1,
        image:image,
        documentName:"SSLC Document",
        number:20486,
        expiryDate:"20 Jan 2040"
      },
      {
        id:2,
        image:image,
        documentName:"DDL Document",
        number:12345,
        expiryDate:"15 Mar 2030"
      },
      {
        id:3,
        image:image,
        documentName:"HSC Document",
        number:56889,
        expiryDate:"09 May 2035"
      }
]


export const complianceFilterData = [
  {
    id: 1,
    primaryText: 'Status',
    isOpen: true,
    subItems: [
      { label: 'Approved', value: 'Approved' },
      { label: 'Pending', value: 'Pending' },
    ]
  },
]